import { STANDARD_BRANCH } from '@festina-life/api'
import { dateUtils } from '@festina-life/core'
import cx from 'classnames'

import { useParameterContext } from '../../context/parameterContext'
import type { ParameterValueEntityOperation } from '../../uiModels/parameterOperations/types'
import type { OperationWithSourceInfo } from '../../uiModels/types'
import { useRequiredBranchOperationsContext } from '../../workspace/operationsContext'
import { Attribute } from '../attribute/Attribute'
import { BlockIndicator } from '../blockIndicator/BlockIndicator'
import { ConfigurationItemIcon } from '../configurationItemIcon/ConfigurationItemIcon'
import { operationLinkClassName } from '../configurationOperationLink/helpers'
import { LayerIndicator } from '../layerIndicator/LayerIndicator'
import { OperationApprovalStatus } from '../operationApproval/OperationApprovalStatus'

type Props = {
  operation: OperationWithSourceInfo<ParameterValueEntityOperation>
}

export const ParameterValueOperation = ({ operation }: Props) => {
  const { reviewingOperation, onReviewOperation } = useParameterContext()
  const { branchKey } = useRequiredBranchOperationsContext()
  const internalOperation = operation.internalOperation
  const { operationKey } = internalOperation
  const isApprovalEnabled = branchKey && branchKey.name !== STANDARD_BRANCH

  const fromDateString = internalOperation.entity?.fromDate
  const toDateString = internalOperation.entity?.toDate
  const isCurrentOperationBeingReviewed =
    reviewingOperation &&
    reviewingOperation.internalOperation.operationKey === operationKey

  return (
    <li className="flex items-center gap-x-2">
      {isApprovalEnabled && (
        <OperationApprovalStatus
          variant="compact"
          actions={operation.actions}
        />
      )}
      <button
        className={cx(
          'text-start!',
          operationLinkClassName({
            isInteractive: true,
            isDraft: operation.isDraft,
          }),
          isCurrentOperationBeingReviewed
            ? 'bg-primary-200 dark:bg-primary-700'
            : '',
        )}
        onClick={() =>
          onReviewOperation(
            isCurrentOperationBeingReviewed ? undefined : operationKey,
          )
        }
      >
        <ConfigurationItemIcon type="parameterValue" />
        <div className="flex-1">
          <Attribute className="text-wrap wrap-break-word">{`${fromDateString ? dateUtils.dateAsStr(fromDateString) : ''} - ${toDateString ? dateUtils.dateAsStr(toDateString) : ''}`}</Attribute>
        </div>

        <div className="flex flex-row items-center gap-x-1">
          <BlockIndicator block={operation.block} shouldShowIcon={false} />
          <LayerIndicator
            layer={operation.layer}
            isSecondaryBackground={false}
          />
        </div>
      </button>
    </li>
  )
}
